export const environment = {
  production: true,
  buildId: '2801518738019091',
  configFile: 'config.json',
};
